import { css } from '@emotion/react';
import { Header, Logo, Navigation, NavigationLink } from '@rr/ui';
import { Button, useMantineTheme, Card, Avatar } from '@mantine/core';
import { useAuth } from '@rr/auth-context';
import * as ROUTES from 'config/routes';

const NAVIGATION: NavigationLink[] = [
  {
    to: ROUTES.STUDENTS,
    label: 'Students',
  },
  {
    to: ROUTES.TEACHERS,
    label: 'Teachers',
  },
  {
    to: ROUTES.LOCATIONS,
    label: 'Locations',
  },
  {
    to: ROUTES.GUARDIANS,
    label: 'Guardians',
  },
  {
    to: ROUTES.INSTRUMENTS,
    label: 'Instruments',
  },
  {
    to: ROUTES.USERS,
    label: 'Users',
    admin: true,
  },
  {
    to: ROUTES.PLANS,
    label: 'Plans',
  },
  {
    to: ROUTES.INVOICES,
    label: 'Invoices',
    admin: true,
  },
  {
    to: ROUTES.LESSONS,
    label: 'Lessons',
    admin: true,
  },
];

const Layout: React.FC = ({ children }) => {
  const theme = useMantineTheme();
  const styles = css`
    background: ${theme.colors.blue[7]};
    height: 100vh;

    .content {
      flex: 1 0 auto;
      height: calc(100vh - 64px);
    }

    .Avatar {
      margin-left: auto;
      margin-right: 8px;
    }

    .SplitLayout {
      display: flex;
      height: 100%;
      padding: 0 24px;
      gap: 24px;
    }
  `;

  const { logout, user } = useAuth();

  return (
    <main css={styles}>
      <Header>
        <Logo />
        <Navigation items={NAVIGATION} />
        <Avatar className="Avatar" radius="xl" color="blue">
          {user && user.email && user.email.charAt(0).toUpperCase()}
        </Avatar>
        <Button variant="subtle" className="Logout" onClick={logout}>
          Log out
        </Button>
      </Header>
      <div className="content">{children}</div>
    </main>
  );
};

export { Layout };
